<div class="address-container" [ngClass]="{'selected': selected()}">
    <div class="address-info-container" [ngClass]="{'selected': selected()}">
        <button class="button-undecorated info-button" (click)="action.emit('select')">
            <cwo-icon [name]="icon()" class="address-type-icon" />
            <div class="text-wrapper">
                <span class="address-name">{{address().name}}</span>
                <span class="address-info">{{addressInfo()}}</span>
            </div>
        </button>
        <div class="action-buttons-wrapper">
            <button class="button-undecorated" (click)="action.emit('edit')" [attr.aria-label]="'Edit address ' + address().name">
                <cwo-icon [name]="iconNameType.edit" class="action-button-icons" />
            </button>
            <div class="separator" [ngClass]="{'selected': selected()}"></div>
            <button class="button-undecorated" (click)="action.emit('delete')" [attr.aria-label]="'Delete address ' + address().name">
                <cwo-icon [name]="iconNameType.delete" class="action-button-icons" />
            </button>
        </div>
    </div>
    @if(address().warnings?.length){
        <div class="warning-wrapper">
            <div class="error-icon">
                <span>!</span>
            </div>
            {{address().warnings![0]}}
        </div>
    }
</div>
